import React, { Component } from "react"
import RestContextHOC from "../../Contexts/RestContextHOC"
import UserContextHOC from "../../Contexts/UserContextHOC"
import CartContextHOC from "../../Contexts/CartContextHOC"
import AnalyticsContextHOC from "../../Contexts/AnalyticsContextHOC"
const formatPrice = require("../../helpers/formatPrice")

import "./CreditCardFee.css"
import { Fee } from "./fee"
import { Stars } from "./stars"
import { Thumb } from "./thumb"
import { Alert } from "./alert"

class CreditCardFee extends Component {
  render() {
    return null
  }
}

export const FeeNotification = () => null

export const AvoidCardFees = () => null

export const AvoidApplePayFees = () => null

export const DebitSavings = () => null

export const ApplePayAlert = () => null

export default RestContextHOC(
  AnalyticsContextHOC(CartContextHOC(UserContextHOC(CreditCardFee)))
)
